export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الشركة"])}
        }
      },
      "ar-EG": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الشركة"])}
        }
      },
      "ar-SA": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الشركة"])}
        }
      },
      "de-DE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])}
        }
      },
      "de-AT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])}
        }
      },
      "de-CH": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])}
        }
      },
      "en-US": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Settings"])}
        }
      },
      "en-GB": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Settings"])}
        }
      },
      "it-IT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni Azienda"])}
        }
      },
      "fr-FR": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'Entreprise"])}
        }
      },
      "es-ES": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de la Empresa"])}
        }
      },
      "pl-PL": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia Firmy"])}
        }
      },
      "nl-NL": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsinstellingen"])}
        }
      },
      "bg-BG": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на Kомпанията"])}
        }
      },
      "bs-BA": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke Kompanije"])}
        }
      },
      "da-DK": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedsindstillinger"])}
        }
      },
      "et-EE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte Seaded"])}
        }
      },
      "fi-FI": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yrityksen Asetukset"])}
        }
      },
      "el-GR": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Εταιρείας"])}
        }
      },
      "he-IL": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות חברה"])}
        }
      },
      "ga-IE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Cuideachta"])}
        }
      },
      "ja-JP": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会社の設定"])}
        }
      },
      "hr-HR": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke Tvrtke"])}
        }
      },
      "lv-LV": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzņēmuma Lestatījumi"])}
        }
      },
      "lt-LT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės Nustatymai"])}
        }
      },
      "pt-PT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações da Empresa"])}
        }
      },
      "ro-RO": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări Companie"])}
        }
      },
      "ru-RU": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки Kомпании"])}
        }
      },
      "sv-SE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagsinställningar"])}
        }
      },
      "sk-SK": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia Spoločnosti"])}
        }
      },
      "cs-CZ": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení Společnosti"])}
        }
      },
      "tr-TR": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Ayarları"])}
        }
      },
      "hu-HU": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati Beállítások"])}
        }
      },
      "fr-BE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'Entreprise"])}
        }
      },
      "fr-LU": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'Entreprise"])}
        }
      },
      "mt-MT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-Kumpanija"])}
        }
      },
      "sl-SI": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve Podjetja"])}
        }
      },
      "el-CY": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Εταιρείας"])}
        }
      },
      "tr-CY": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Ayarları"])}
        }
      },
      "uk-UA": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування Kомпанії"])}
        }
      },
      "zh-CN": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司设定"])}
        }
      }
    }
  })
}
